import { watch as h } from "vue";
import { createRegionCodeProvider as l } from "@ado/location-library";
import { getPageMetadata as f } from "../api/services/index.js";
import { SearchCriteria as m } from "../api/types/index.js";
let o = [];
function p(r) {
  const i = document.getElementsByTagName("head");
  let n;
  i.length > 0 ? n = i[0] : (n = document.createElement("head"), document.getElementsByTagName("html")[0].appendChild(n)), o.forEach((e) => {
    n.removeChild(e);
  }), o = [];
  const c = r.link, s = r.meta, d = n.getElementsByTagName("title");
  let a;
  d.length > 0 ? a = d[0] : (a = document.createElement("title"), n.appendChild(a)), a.innerHTML = r.title, s.forEach((e) => {
    const t = document.createElement("meta");
    e.property && t.setAttribute("property", e.property), e.name && (t.name = e.name), e.content && (t.content = e.content), e.charset && t.setAttribute("charset", e.charset), n.appendChild(t), o.push(t);
  }), c.forEach((e) => {
    const t = document.createElement("link");
    e.href && (t.href = e.href), e.rel && (t.rel = e.rel), e.type && (t.type = e.type), e.hreflang && (t.hreflang = e.hreflang), e.sizes && t.setAttribute("sizes", e.sizes), n.appendChild(t), o.push(t);
  });
}
function T(r) {
  h(
    r,
    (i) => {
      !i.enabled || u(i).then((n) => {
        n.succeeded && p(n.result);
      });
    },
    { immediate: !0 }
  );
}
function u(r) {
  const i = window.location.href.replace(window.location.hash, ""), n = l().provideRegionCode(), c = new m(
    i,
    r.productCode,
    n,
    r.nameVariation
  );
  return f(c);
}
export {
  u as getPageMetaData,
  T as useMeta
};
//# sourceMappingURL=index.js.map
